export default __webpack_public_path__ + "static/media/zodiacToto-Goat.5522c847.png";